import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { KycIcon } from "../../../components/icons/status";
import { useFetchable } from "../../../store/common/fetchable";
import { isFetchableSuccess } from "../../../store/common/fetchable/helpers";
import { Users } from "../../../store/users/reducer";
import { device } from "../../../styles/media";
import { FormWidget } from "./components";
import { ConfigContext } from "./config-context";

const StyledWidget = styled(FormWidget)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5em;
  margin-bottom: 1em;
  width: 100%;

  @media ${device.laptop} {
    justify-content: flex-end;
  }
`;

const FullKycIcon = styled.div`
  margin-left: 1em;
`;

interface IKYCVerificaitonSectionProps {}

export const KYCVerificaitonSection: React.FunctionComponent<IKYCVerificaitonSectionProps> = (
  props
) => {
  const userDetails = useFetchable(Users.current);
  const {
    state: { userKycStatus },
  } = useContext(ConfigContext);

  const { t } = useTranslation("token-onboarding");

  return isFetchableSuccess(userDetails) ? (
    <StyledWidget>
      {t("welcome-user", { ...userDetails.data })}
      <FullKycIcon>{KycIcon(userDetails.data.kycStatus, "kyc")}</FullKycIcon>
    </StyledWidget>
  ) : userKycStatus ? (
    <StyledWidget>
      <FullKycIcon>{KycIcon(userKycStatus, "kyc")}</FullKycIcon>
    </StyledWidget>
  ) : null;
};
